module.exports = __webpack_public_path__ + "img/news_02.2b48c09c.png";